export default __webpack_public_path__ + "static/identity-32871ad9511c23968f6e68530d1897bd.png";